import React from 'react';
import { useRecoilValue } from 'recoil';
import { darkModeState } from '../../../../../atoms';
import { BackgroundSwitcher } from './BackgroundSwitch';
import classNames from './Theme.module.scss';

export interface SwitchProps {
  isEnterState?: boolean;
}

export const Switch: React.FC<SwitchProps> = ({ isEnterState }) => {
  const darkMode = useRecoilValue(darkModeState);
  const theme = !darkMode
    ? isEnterState
      ? classNames.backgroundSwitchEnterState
      : classNames.backgroundSwitch
    : isEnterState
    ? classNames.backgroundSwitchEnterStateDark
    : classNames.backgroundSwitchDark;

  return (
    <div className={theme}>
      <BackgroundSwitcher access={isEnterState!} className={classNames} />
    </div>
  );
};
